import { firebaseAuth } from '../firebase/auth';

const API_URL = import.meta.env.VITE_API_URL;

export interface ProfileUpdateData {
  bio?: string;
  expectations?: string;
  darkMode?: boolean;
  language?: string;
  notifications?: boolean;
}

export interface NotificationTimeRequest {
  period: 'morning' | 'evening';
  hour: number;
}

export interface NotificationPeriodRequest {
  period: 'morning' | 'evening';
  enabled: boolean;
}

export interface NotificationPreferences {
  enabled: boolean;
  morning: {
    enabled: boolean;
    time: number;
  };
  evening: {
    enabled: boolean;
    time: number;
  };
}

class ProfileAPI {
  private async request(endpoint: string, options: RequestInit = {}) {
    const idToken = await firebaseAuth.getIdToken();
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`,
      ...options.headers
    };

    const response = await fetch(`${API_URL}${endpoint}`, {
      ...options,
      headers
    });

    if (!response.ok) {
      throw new Error(await response.text());
    }

    return response.json();
  }

  async updateProfile(data: ProfileUpdateData) {
    return this.request('/api/profile', {
      method: 'PATCH',
      body: JSON.stringify(data)
    });
  }

  async setNotificationTime(request: NotificationTimeRequest) {
    return this.request('/api/profile/notification-time', {
      method: 'PATCH',
      body: JSON.stringify(request)
    });
  }

  async toggleNotificationPeriod(request: NotificationPeriodRequest) {
    return this.request('/api/profile/notification-period', {
      method: 'PATCH',
      body: JSON.stringify(request)
    });
  }

  async getNotificationPreferences(): Promise<{ success: boolean; data: NotificationPreferences }> {
    return this.request('/api/profile/notification-preferences', {
      method: 'GET'
    });
  }

  async getProfile() {
    return this.request('/api/profile', {
      method: 'GET'
    });
  }
}

export const profileAPI = new ProfileAPI();